import LoginLayout from "../LoginLayout"
import { connect } from "react-redux"
import { CreatePasswordFormValues, ForgotPasswordFormValues, FormPageProps } from "../../../../types"
import { login, createPassword } from "../../../../actions/loginActions"
import { useNavigate, useParams } from "react-router-dom"
//@ts-ignore
import EyeIcon from "../../../ui/img/auth/eye.svg"
//@ts-ignore
import EyeSlashIcon from "../../../ui/img/auth/eye-slash.svg"
//@ts-ignore
import PasswordIcon from "../../../ui/img/auth/password.svg"
import { useEffect, useState } from "react"
import { KButton, KCodeInput, KInput, KSpan, KTitleSpan } from "kahuna-base-react-components"
import { lang } from "../../../../constants/languages"
import { DEFAULT_ROUTE, errorFilledToastOptions, successFilledToastOptions } from "../../../../constants"
import { toast } from "react-toastify"
import { codeValidation as codeValidationApi } from "../../../../apis"
import { mapToSnakeCase } from "../../../../utility"
import axios from "axios"
const CreatePassword = (props: FormPageProps<CreatePasswordFormValues>) => {
  const [form, setForm] = useState<CreatePasswordFormValues>({ email: "" })
  const [codeValidationSendForm, setCodeValidationSendForm] = useState<ForgotPasswordFormValues>({
    email: "",
    ipAddress: ""
  })

  const [showPassword, setShowPassword] = useState(false)
  const [showPasswordAgain, setShowPasswordAgain] = useState(false)
  const [codeSentOnce, setCodeSentOnce] = useState<boolean>(false)
  const [disableButton, setDisableButton] = useState<boolean>(false)
  const [time, setTime] = useState(0)

  const navigate = useNavigate()
  const params = useParams()
  const onSubmit = () => {
    if (form.password !== form.repeatedPassword) {
      toast.error(lang.create_password.password_do_not_match, errorFilledToastOptions)
      return
    }
    props.onSubmit(form, () => {
      if (!props?.login) return 
      props.login({username: form?.email, password: form?.password}, () => navigate(DEFAULT_ROUTE))
    })
  }

  useEffect(() => {
    const getData = async () => {
      const res = await axios.get("https://api.ipify.org/?format=json")
      setCodeValidationSendForm({ ...form, ipAddress: res.data.ip, email: params.email || "" })
    }

    getData().then()
    setForm({ ...form, email: params.email })
  }, [])

  const sendValidationCode = async () => {
    try {
      const response = await codeValidationApi.post(
        "/send_validation/?subject=Create Your Password",
        mapToSnakeCase(codeValidationSendForm)
      )
      if (response.status === 200) {
        toast.success(lang.create_password.success_on_code_sent, successFilledToastOptions)
      } else {
        toast.error(lang.create_password.error_on_code_sent, errorFilledToastOptions)
      }
    } catch {
      toast.error(lang.create_password.error_on_code_sent, errorFilledToastOptions)
    }
  }

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${String(minutes).padStart(2, "0")}:${String(remainingSeconds).padStart(2, "0")}`
  }

  useEffect(() => {
    if (time > 0) {
      const timer = setInterval(() => {
        setTime((prevTime) => prevTime - 1)
      }, 1000)

      return () => {
        clearInterval(timer)
      }
    }
    if (time === 0) {
      setDisableButton(false)
    }
  }, [time])

  return (
    <LoginLayout>
      <div className={"grid align-middle justify-center items-center"} style={{ width: "100%", height: "90%" }}>
        <div className={"grid"} style={{ width: 500 }}>
          <div className={"flex"}>
            <KTitleSpan text={lang.create_password.title} />
          </div>
          <div className={"mt-8"}>
            <KInput
              type="number"
              value={form.code || ""}
              onChange={(text) => setForm({ ...form, code: text })}
              placeholder={lang.create_password.code_placeholder}
            />
          </div>
          <div className={"mt-4"}>
            <KInput
              value={form.password || ""}
              onChange={(text) => setForm({ ...form, password: text })}
              type={showPassword ? "text" : "password"}
              placeholder={lang.create_password.password_placeholder}
              leftIcon={PasswordIcon}
              rightIconClick={() => setShowPassword(!showPassword)}
              rightIcon={showPassword ? EyeIcon : EyeSlashIcon}
            />
          </div>
          <div className={"mt-4"}>
            <KInput
              value={form.repeatedPassword || ""}
              onChange={(text) => setForm({ ...form, repeatedPassword: text })}
              type={showPasswordAgain ? "text" : "password"}
              placeholder={lang.create_password.repeat_password_placeholder}
              leftIcon={PasswordIcon}
              rightIconClick={() => setShowPasswordAgain(!showPasswordAgain)}
              rightIcon={showPasswordAgain ? EyeIcon : EyeSlashIcon}
            />
          </div>
          <div
            style={{
              marginTop: codeSentOnce ? 32 : 8
            }}
          >
            {codeSentOnce && (
              <KButton
                onClick={() => onSubmit()}
                text={lang.create_password.create_password_button}
                background="#111"
                textColor="white"
                disabled={!form.password || !form.repeatedPassword || !(form?.code && form?.code.length === 6)}
              />
            )}
            {time === 0 ? (
              <div className="mt-2">
                <KButton
                  shadowDisabled={true}
                  background="black"
                  textColor="white"
                  onClick={() => {
                    if (!disableButton) setDisableButton(true)
                    sendValidationCode().then(() => {
                      setTime(180)
                      if (!codeSentOnce) setCodeSentOnce(true)
                    })
                  }}
                  disabled={disableButton}
                  text={codeSentOnce ? lang.create_password.resend_code : lang.create_password.request_code}
                />
              </div>
            ) : (
              <div className="ml-4 flex justify-center items-center h-11">
                <KSpan text={formatTime(time)} lineHeight="14px" />
              </div>
            )}
          </div>
        </div>
      </div>
    </LoginLayout>
  )
}

export default connect(null, { login, onSubmit: createPassword })(CreatePassword)
